var map = {
	"./1.jpg": 71742,
	"./10.jpg": 33412,
	"./11.jpg": 11457,
	"./12.jpg": 78198,
	"./3.jpg": 79724,
	"./4.jpg": 86039,
	"./5.jpg": 14874,
	"./6.jpg": 19077,
	"./7.jpg": 75112,
	"./8.jpg": 14227,
	"./9.jpg": 42614,
	"./FOX 8.jpg": 40408,
	"./bird 2.jpg": 25724,
	"./bird 3.jpg": 70073,
	"./bird 7.jpg": 30850,
	"./birds 1.jpg": 83502,
	"./birds.jpg": 55003,
	"./boy 2.jpg": 26531,
	"./fox.jpg": 84840,
	"./lion 10.jpg": 27050,
	"./rabbit 10.jpg": 69828,
	"./rabbit 3.jpg": 23468,
	"./sun.jpg": 5841,
	"./teddy.jpg": 23225,
	"./zerafee.jpg": 99475
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 55861;